import { logger } from '@parrot-software/observability';

import type { IPaymentHistoryApiPort } from '@subscriptions/application/ports';
import type { PaymentHistoryFilterDto, PaymentHistoryPageViewDto } from '@subscriptions/application/dtos';
import { extractErrorAttributes } from '@subscriptions/application/utils';

const historyLog = logger.forDomain('SUB', { subdomain: 'billing' });

/**
 * Use case for listing payment history.
 * PaymentHistory is a DTO-only type — the port returns a PageViewDto with items and pagination metadata.
 *
 * @param port - Payment history API port
 * @returns Use case executor
 */
export const listPaymentHistoryUseCase = (port: IPaymentHistoryApiPort) => {
  const execute = async (params: PaymentHistoryFilterDto): Promise<PaymentHistoryPageViewDto> => {
    try {
      return await port.list(params);
    } catch (error) {
      historyLog.error('listPaymentHistory', extractErrorAttributes(error));
      throw error;
    }
  };

  return { execute };
};
